export default {
  checkboxItemAlign: 'center',
  checkBoxMArginTop: '1.2rem',
  checkMarkColor: 'var(--teal)',
  unmarkedBorder: '2px solid var(--dark-teal-20)',
  checkboxBorderRadius: '5px',
  checkedColor: 'var(--teal)',
};
